export class WriteUs {
    subject = 'Dotaz';
    name: string;
    emailFrom: string;
    phoneNumber: string;
    body: string;
}
